export default "__VITE_ASSET__DQb3YW_f__"